module.exports = __webpack_public_path__ + "static/media/25.0340f2da.jpg";